<div
  class="product-image"
  [style.width]="size || '100%'"
  [style.height]="size || null"
>
  <img
    [src]="currentImageUrl"
    [alt]="'Product image'"
    (error)="onImageError()"
  />
</div>
